var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.138.444H2.557C1.42.444.5 1.316.5 2.39V15.61c0 1.073.921 1.945 2.057 1.945h6.58c1.136 0 2.057-.872 2.057-1.945V2.39c0-1.073-.92-1.945-2.056-1.945zm-3.29 15.264c-.684 0-1.235-.52-1.235-1.166 0-.646.551-1.167 1.234-1.167.683 0 1.234.521 1.234 1.167 0 .645-.551 1.166-1.234 1.166z",
    fill: "url(#smartphone_svg__paint0_linear_889_938)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.138.444H2.557C1.42.444.5 1.316.5 2.39V15.61c0 1.073.921 1.945 2.057 1.945h6.58c1.136 0 2.057-.872 2.057-1.945V2.39c0-1.073-.92-1.945-2.056-1.945zm-3.29 15.264c-.684 0-1.235-.52-1.235-1.166 0-.646.551-1.167 1.234-1.167.683 0 1.234.521 1.234 1.167 0 .645-.551 1.166-1.234 1.166z",
    fill: "url(#smartphone_svg__paint1_linear_889_938)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartphone_svg__paint0_linear_889_938",
    x1: 11.408,
    y1: 0.602,
    x2: -4.137,
    y2: 10.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smartphone_svg__paint1_linear_889_938",
    x1: 11.171,
    y1: 0.482,
    x2: -4.142,
    y2: 10.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#688FA5"
  })))));
}

export default __webpack_public_path__ + "./fonts/smartphone.4113325266a521c73f4dcbd0d4391006.svg";
export { SvgSmartphone as ReactComponent };